<template>
<div id="notify">
  <section class="banner-notif parallax-window" data-parallax="scroll"  :data-image-src="require('@/assets/img/bannernotif.jpg')">
    <div class="container text-center">
      <h1>Notificações</h1>
    </div>
  </section>
  <section class="notif container">
    <div class="row">
      <div class="col-12">
        <div class="box-cursos notificacoes">
          <div class="sticky-top" v-cloak>
            <div class="container">
              <ul class="nav nav-pills float-left float-md-right mt-0 mt-md-4">
                <li v-for="item in notificacoesTipos" :key=item.id class="nav-item" :class="item.categoria">
                  <a class="nav-link" :class="{ active: item.ativo }" data-toggle="pill" href="#" role="tab" @click="carregarNotificacoes(item.id)">{{ item.descricao }}</a>
                </li>
              </ul>
            </div>
            <div class="clearfix"></div>
          </div>
          <div v-for="notif in notificacoes" :key=notif.id :class="notif.tipo_notificacao.categoria">
            <a href="javascript:void(0)" @click="registrarAcesso(notif)" class="d-flex align-items-center" target="_blank">
              <div class="text-center">
                <i class="fas" :class="notif.tipo_notificacao.icone"></i>
              </div>
              <div>
                <span>{{ notif.tipo_notificacao.descricao }}</span>
                <p>{{ notif.notificacao }}</p>
                <p>{{ diasAtras(notif.created_at) }}</p>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import $ from 'jquery'
import 'jquery-parallax.js'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import NotificacaoAPI from '@/api/notificacao-api'
import DateUtils from '@/core/utils/date-utils'
Vue.use(BootstrapVue)

export default {
  name: 'NotificacoesView',
  data () {
    return {
      notificacoes: [],
      notificacoesTipos: [{ id: 'todos', categoria: '', descricao: 'Todos', icone: '', ativo: true }],
      tipo: null,
      quantidade: '',
      paginaAtual: 1,
      totalPaginas: '',
      scrolled: false
    }
  },
  mounted () {
    this.carregarTiposNotificacoes()
    this.carregarNotificacoes(this.tipo, this.paginaAtual)
    this.registrarVisualizacaoTodasNotificacoes()
    this.scroll()
  },
  created () {
    setTimeout(function () {
      $('.parallax-window').parallax({ imageSrc: require('@/assets/img/bannernotif.jpg') })
    }, 100)
  },
  beforeDestroy () {
    $('.parallax-mirror').remove()
  },
  methods: {
    async recuperaNotificacoes (tipo, pagina) {
      const loader = this.$loading.show()
      if (!tipo || tipo === 'todos') {
        const notificacoes = await NotificacaoAPI.obterNotificacao(null, pagina)
        loader.hide()
        return notificacoes
      }
      this.notificacoes = []
      const notificacoesPorTipo = await NotificacaoAPI.obterNotificacaoPorTipo(tipo, pagina)
      loader.hide()
      return notificacoesPorTipo
    },
    async carregarNotificacoes (tipo, pagina) {
      if (tipo) {
        this.notificacoesTipos.forEach(item => {
          item.ativo = item.id === tipo
        })
      }
      window.scrollTo(0, 0)
      this.scrolled = true
      let resposta = await this.recuperaNotificacoes(tipo, pagina)
      this.notificacoes = resposta.notificacoes.data
      this.totalPaginas = resposta.notificacoes.last_page
    },
    async carregarMaisNotificacoes () {
      this.paginaAtual++
      this.scrolled = false
      this.paginaAtual <= this.totalPaginas &&
      this.recuperaNotificacoes(this.tipo, this.paginaAtual).then((resposta) => {
        let novoLoteNotificacoes = Object.values(resposta.notificacoes.data)
        this.notificacoes = [...this.notificacoes, ...novoLoteNotificacoes]
        this.scrolled = true
      })
    },
    async carregarTiposNotificacoes () {
      const tipos = await NotificacaoAPI.obterTiposDeNotificacao()
      this.notificacoesTipos = this.notificacoesTipos.concat(tipos)
    },
    async registrarVisualizacaoTodasNotificacoes () {
      await NotificacaoAPI.registrarVisualizacao()
    },
    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > (document.documentElement.offsetHeight - (document.getElementsByClassName('footer')[0].offsetHeight + 100))
        if (bottomOfWindow) {
          this.scrolled &&
          this.carregarMaisNotificacoes()
        }
      }
    },
    async registrarAcesso (notif) {
      await NotificacaoAPI.registrarAcesso(notif.id)
      this.$router.push(notif.url)
    },
    diasAtras (createdAt) {
      return DateUtils.diasAtras(createdAt)
    }
  }
}
</script>
